export default __webpack_public_path__ + "static/media/elevate-dmb-poster-1.8ca9b745.jpg";